module.exports = __webpack_public_path__ + "static/media/workingOnIt.7b6e726b.png";